import { axios, storage } from '../utils'

const state = {
  /**
   * 客户端会话信息
   * @type {Object}
   * TODO: storage - local or session
   */
  session: storage.get('dashoo_session_info') || {},

  /**
   * 顶部工具栏
   * @type {Object}
   */
  header: {
    /**
     * 站点名称
     * @type {String}
     */
    // name: '369云管',
    name: 'LabSOP',
    /**
     * 顶部菜单
     * @type {Array}
     */
    menus: [
      {
        text: '平台首页',
        icon: 'home',
        name: 'dashboard'
      },
      {
        text: '设备日报',
        icon: 'stats-bars',
        name: 'reports'
      },
      {
        text: '提醒设置',
        icon: 'alarm',
        name: 'abnormalsetting'
      },
      {
        text: '账户设置',
        icon: 'credit-card',
        name: 'usersetting'
      }
      // Demo Pages
      // {
      //   text: '演示',
      //   icon: 'magic-wand',
      //   name: 'demo',
      //   children: [
      //     { text: 'Icons', name: 'components-icons' },
      //     { text: 'Button', name: 'components-button' },
      //     { text: 'Table', name: 'components-table' },
      //     { text: 'Data', name: 'demo-data' },
      //     { text: 'Params', name: 'demo-params', params: { name: '汪磊' } },
      //     { text: 'Vuex', name: 'demo-vuex' },
      //     { text: 'I18n', name: 'demo-i18n' },
      //     { divider: true },
      //     { text: 'CORS', name: 'demo-cors' },
      //     { divider: true },
      //     { text: 'NotFound', path: '/hello-world' }
      //   ]
      // }
    ]
  },

  /**
   * 侧边导航栏
   * @type {Object}
   */
  sidebar: {
    /**
     * 版权所属
     * @type {String}
     */
    // copyright: '369云管',
    // copyright: 'LabSOP',
    copyright: 'MCS-01',
    /**
     * 是否收起边栏
     * @type {Boolean}
     */
    collapse: storage.get('dashoo_sidebar_collapse'),

    /**
     * 侧边菜单
     * @type {Array}
     */
    menus: [
      {
        title: ''
      },
      {
        text: '平台首页',
        icon: 'home3',
        name: 'dashboard'
      },
      {
        text: '设备管理',
        icon: 'laptop',
        name: 'equipment'
      },
      {
        text: '网关管理',
        icon: 'drive',
        name: 'sgmanage',
        params: { type: 'sgmanage' }
      },
      {
        text: '报警管理',
        icon: 'bell',
        name: 'actions',
        children: [
          { text: '报警项目', name: 'actions' },
          { text: '报警器管理', name: 'alerts' },
          { text: '报警历史', name: 'triggerinfos' }
        ]
      },
      {
        text: '报表输出',
        icon: 'table',
        name: 'reports',
        children: [
          { text: '设备日报', name: 'reports' },
          { text: '周报月报', name: 'monthreports', params: { type: 'plugin' } },
          { text: '数据输出', name: 'dataexports', params: { type: 'plugin' } },
          { text: '曲线报表', name: 'chartreport' },
          { text: '科室报表', name: 'organreport' },
          { text: '开锁报表', name: 'record_history_lock' }
        ]
      },
      {
        text: '用户管理',
        icon: 'users',
        name: 'users'
      },
      {
        text: '账户管理',
        icon: 'credit-card',
        name: 'usersetting',
        children: [
          { text: '账户设置', name: 'usersetting' },
          { text: '组织管理', name: 'organize' },
          { text: '过期模块', name: 'expirechannels' },
          { text: '账户一览', name: 'management' },
          { text: '密码修改', name: 'userchangepwd' }
        ]
      },
      {
        text: '日志管理',
        icon: 'file-text2',
        name: 'loginfo'
      },
      {
        text: '系统设置',
        icon: 'cog',
        name: 'abnormalsetting',
        children: [
          // { text: '常规', name: 'options', params: { type: 'general' } },
          // { divider: true },
          { text: '异常提醒', name: 'abnormalsetting' },
          { text: '异常历史', name: 'abnormalmsg' }
          // { text: '访问授权', name: 'authcodeman' }
        ]
      },
      {
        text: '使用手册',
        icon: 'book',
        isexturl: true,
        url: 'https://www.yuque.com/dashoo/labsop_mcs/pprryo',
        target: '_blank',
        name: 'doc'
      }
    ]
  },

  // ==================== DEMO ====================

  /**
   * 计数器
   * @type {Number}
   */
  count: storage.get('dashoo_demo_count') || 0
}

if (state.session && state.session.token) {
  // init axios headers
  axios.defaults.headers.Authorization = `Bearer ${state.session.token}`
}

export default state



// WEBPACK FOOTER //
// ./src/libraries/store/state.js